export class UserFilter {
  firstName : string;
  lastName : string;
  clientId : number;
  userName : string;
  email : string;
  userId : number;
}